export function setHelpIconClicked() {
  return { type: "HELP_ICON_CLICKED" }
}



// WEBPACK FOOTER //
// ./src/state/actions/helpActions.js